'use client'

import { useLocale, useTranslations } from 'next-intl'
import { formatNumberToNumericalAbreviation } from 'utils/number'
import { defaultContentLanguage, mapLocaleToContentLanguage } from 'cf-i18n/constants'

import { useContentFetchReviewsQuery } from '@web/gen/content'
import { Stat } from './stat'
import { Rating } from '../rating/rating'
import { MAX_REVIEWS } from '../reviews/reviews'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  productId: string
  className?: string
  hideDescription?: boolean
  clickable?: boolean
}

export function RatingStat({ productId, className, hideDescription, clickable, ...rest }: Props) {
  const t = useTranslations('prod.product_description_page.reviews')
  const locale = useLocale()
  const contentLanguage = mapLocaleToContentLanguage.get(locale) || defaultContentLanguage
  const { data, isPending } = useContentFetchReviewsQuery({
    input: {
      productId,
      language: contentLanguage,
      limit: MAX_REVIEWS,
    },
  })
  const rating = data?.contentProductReviews.rating.average ?? 0
  const reviewsNb = data?.contentProductReviews.rating.count ?? 0

  if (isPending || rating === 0) {
    return null
  }

  return (
    <Stat
      className={className}
      // oxlint-disable-next-line no-unneeded-ternary
      icon={<Rating value={rating} className="h-6" readOnly={clickable ? false : true} />}
      value={
        hideDescription
          ? ''
          : t('review_stats', {
              reviewsNb,
              score: rating.toFixed(1),
            }).replace(
              `${reviewsNb.toLocaleString()}`,
              formatNumberToNumericalAbreviation(reviewsNb),
            )
      }
      {...rest}
    />
  )
}
